import React from 'react';
import { Minus, Plus } from 'lucide-react';

const ZOOM_STEPS = [80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200];

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  btn: {
    background: 'rgba(255,255,255,0.16)',
    border: '1px solid rgba(255,255,255,0.28)',
    color: '#fff',
    cursor: 'pointer',
    padding: '4px 6px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    fontSize: '12px',
    color: '#fff',
    minWidth: '36px',
    textAlign: 'center',
    fontWeight: '600',
  },
};

export default function ZoomControls({ zoomLevel = 100, onZoomChange }) {
  const currentIdx = ZOOM_STEPS.indexOf(zoomLevel);

  const zoomOut = () => {
    const idx = currentIdx > 0 ? currentIdx - 1 : 0;
    onZoomChange(ZOOM_STEPS[idx]);
  };

  const zoomIn = () => {
    const idx = currentIdx < ZOOM_STEPS.length - 1 ? currentIdx + 1 : ZOOM_STEPS.length - 1;
    onZoomChange(ZOOM_STEPS[idx]);
  };

  return (
    <div style={styles.container}>
      <button style={styles.btn} onClick={zoomOut}><Minus size={14} /></button>
      <span style={styles.label}>{zoomLevel}%</span>
      <button style={styles.btn} onClick={zoomIn}><Plus size={14} /></button>
    </div>
  );
}
